/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { setSelected, setApproval } from "./brqaSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showDialog,
  StatusFormatter,
  formatCurrency,
  attachFormatter,
} from "../../utility";
import { selectApproval, createApproval, selectLoading } from "./brqaSlice";

export const BrqaTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const showDetail = (column) => {
    dispatch(setSelected(column));
    history.push("/brqa/detail-data");
  };

  const linkFormatter = (cell, column) => {
    return (
      <a onClick={() => showDetail(column)}>
        <strong style={{ color: "blue" }}>{cell} </strong>
      </a>
    );
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      formatter: linkFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "APL Sales Office",
      dataField: "salesOffice",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Doc Date",
      dataField: "docDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Code",
      dataField: "clientCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Qty",
      dataField: "qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Uom",
      dataField: "uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Return Uom",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Net Sales",
      dataField: "netPrice",
      sort: true,
      formatter: formatCurrency,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Nra",
      dataField: "nra",
      sort: true,
      formatter: StatusFormatter,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      formatter: attachFormatter,
    },
    {
      text: "Remark",
      dataField: "remark",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const onSelectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelectAll: (status) => {
      setOnSelectAll(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };



  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="approvalDetailId"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        selectRow={onSelectRow}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      {/* Footer */}
      <Row className="mt-4">
        <Col sm={1}>
          <Button
            variant="success"
            onClick={() => {
              if (onSelectAll) {
                dispatch(setApproval(data));
                history.push(`/brqa/brqa-detail`);
              } else if (selectedRows.length > 0) {
                dispatch(setApproval(selectedRows));
                history.push(`/brqa/brqa-detail`);
              } else {
                showDialog("Please select row first");
              }
            }}
          >
            Next
          </Button>
        </Col>
        <Col sm={1}>
          <Button variant="outline-danger" onClick={() => history.push("/")}>
            Back
          </Button>
        </Col>
        
      </Row>
    </>
  );
};
